import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectHeaderNavigationState = (state: RootState) =>
  state.headerNavigationState;

export const selectHeaderNavLinks = createSelector(
  selectHeaderNavigationState,
  (state) => state.navLinks,
);

export const selectVisibleLinks = createSelector(
  selectHeaderNavigationState,
  (state) => state.visibleLinks,
);
